<template>
  <div>
    <el-dialog @close="handleClose" title="提示" :visible.sync="stateDialog" width="25%">
      <!-- 已申请 -->
      <div class="dialog-wapper" v-if="stateVal == 2">
        <p>您已提交过申请，可在 <span>个人中心-我的申请</span> 中查看！</p>
        <div class="dialog-footer">
          <span slot="footer">
            <el-button @click="stateDialog = false">暂不</el-button>
            <el-button type="primary" @click="toMine">去个人中心</el-button>
          </span>
        </div>
      </div>
      <!-- 订购中 -->
      <div class="dialog-wapper" v-if="stateVal == 3">
        <p class="dialogleft">该资源已在订购中！</p>
        <p class="dialogleft">
          <label v-if="!phone">请先绑定手机号，</label>订购成功后，您将收到短信通知。可在
          <span>个人中心-我的申请</span> 中查看并下载资源。
        </p>

        <div class="dialog-footer">
          <span slot="footer" v-if="!phone">
            <el-button @click="stateDialog = false">暂不</el-button>
            <el-button type="primary" @click="bindPhone">绑定手机号</el-button>
          </span>
          <span slot="footer" v-else>
            <el-button type="primary" @click="stateDialog = false">我知道了</el-button>
          </span>
        </div>
      </div>
      <!-- 资源失踪 -->
      <div class="dialog-wapper" v-if="stateVal == 4">
        <p>资源失踪了！可先收藏，稍后再试。</p>
        <div class="dialog-footer">
          <span slot="footer">
            <el-button type="primary" @click="stateDialog = false">我知道了</el-button>
          </span>
        </div>
      </div>
      <!-- 获取成功 -->
      <div class="dialog-wapper" v-if="stateVal == 5">
        <p class="dialogleft">获取成功！</p>
        <p class="dialogleft">
          <label v-if="!phone">请先绑定手机号，</label>收到短信后，可在
          <span>个人中心-我的申请</span> 中下载资源。
        </p>
        <div class="dialog-footer">
          <span slot="footer" v-if="!phone">
            <el-button @click="stateDialog = false">暂不</el-button>
            <el-button type="primary" @click="bindPhone">绑定手机号</el-button>
          </span>
          <span slot="footer" v-else>
            <el-button type="primary" @click="stateDialog = false">我知道了</el-button>
          </span>
        </div>
      </div>
      <!-- 资源需要申请 -->
      <div class="dialog-wapper" v-if="stateVal == 6 && !submitFlag">
        <p>该资源需要申请！是否提交申请？</p>
        <div class="dialog-footer">
          <span slot="footer">
            <el-button @click="stateDialog = false">取消</el-button>
            <el-button type="primary" @click="submitRecorce">提交</el-button>
          </span>
        </div>
      </div>
      <!-- 提交申请成功 -->
      <div class="dialog-wapper" v-if="stateVal == 6 && submitFlag">
        <p class="dialogleft">提交成功！</p>
        <p class="dialogleft">
          <label v-if="!phone">请先绑定手机号，</label
          >申请结果将以短信形式发送给您，请注意查收！也可在
          <span>个人中心-我的申请</span> 中查看申请状态。
        </p>
        <div class="dialog-footer">
          <span slot="footer" v-if="!phone">
            <el-button @click="stateDialog = false">暂不</el-button>
            <el-button type="primary" @click="bindPhone">绑定手机号</el-button>
          </span>
          <span slot="footer" v-else>
            <el-button type="primary" @click="stateDialog = false">我知道了</el-button>
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="绑定手机号" :visible.sync="bindPhoneVisible" width="30%">
      <div class="dialogInfo">
        <div class="item flex">
          手机号:
          <div class="flex phone">
            <el-input placeholder="请输入手机号" v-model="phoneVal" />
            <span class="code" v-if="show" @click="getCode">发送验证码</span>
            <span class="code" v-else>{{ times }}</span>
          </div>
        </div>
        <div class="item flex">
          验证码:
          <el-input placeholder="请输入验证码" v-model="codeVal" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindPhoneVisible = false">取消</el-button>
        <el-button type="primary" @click="saveBindPhone">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import urlobj from "@/api/baseurl.js";
export default {
  name: "top",
  props: {
    stateVal: {
      type: Number,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    bodyItemDialog: {
      type: Object,
    },
  },
  watch: {
    dialogVisible: {
      handler(n, o) {
        this.stateDialog = n;
        if (this.stateDialog) {
          this.getPhone();
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      bindPhoneVisible: false,
      stateDialog: false,
      phone: "",
      phoneVal: "",
      codeVal: "",
      times: 60,
      show: true,
      submitFlag: false,
    };
  },
  mounted() {},
  methods: {
    getPhone() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.phone = res.data.phone;
      });
    },
    bindPhone() {
      this.stateDialog = false;
      this.bindPhoneVisible = true;
    },
    getCode() {
      if (!this.phoneVal) {
        this.$message.error("请输入手机号");
        return;
      }
      this.times = 60;
      let formData = new FormData();
      formData.append("mobilePhone", this.phoneVal);

      this.$http({
        url: "api/v1/user/sendCode",
        method: "POST",
        data: formData,
      }).then(res => {
        this.show = false;
        this.timer = setInterval(() => {
          this.times--;
          if (this.times === 0) {
            this.show = true;
            clearInterval(this.timer);
          }
        }, 1000);
      });
    },
    saveBindPhone() {
      if (!this.phoneVal) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phoneVal.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phoneVal)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      if (!this.codeVal) {
        this.$message.error("请输入验证码");
        return;
      }
      let formData = new FormData();
      formData.append("newMobile", this.phoneVal);
      formData.append("smsCode", this.codeVal);
      this.$http({
        url: "api/v1/user/changephone",
        method: "POST",
        data: formData,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
          this.bindPhoneVisible = false;
          this.phoneVal = "";
          this.codeVal = "";
        }
      });
    },
    submitRecorce() {
      let postBody = {
        doi: this.bodyItemDialog.doi,
        title: this.bodyItemDialog.title,
        paperPrice: this.bodyItemDialog.paperPrice,
        singlePrice: this.bodyItemDialog.singlePrice,
        totalPrice: this.bodyItemDialog.totalPrice,
        badWord: this.bodyItemDialog.badWord,
      };
      this.$http({
        url: "/api/v1/wantbuyR/apply",
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          this.submitFlag = true;
        }
      });
    },
    handleClose() {
      this.submitFlag = false;
      this.$emit("closeDialog", false);
    },
    toMine() {
      this.$router.push({ path: "/mine" });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-wapper {
  color: #333;
  .dialogleft {
    text-align: left;
  }
  p {
    text-align: center;
    font-size: 16px;
    line-height: 30px;
    span {
      color: #2d8cf0;
    }
  }
  .dialog-footer {
    margin-top: 30px;
    text-align: right;
    .el-button {
      border-radius: 0;
    }
  }
}
.dialogInfo {
  padding: 0 40px;
  .item {
    align-items: center;
    margin-bottom: 15px;
    font-size: 16px;
    &:last-of-type {
      margin: 0;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
    .el-input {
      flex: 1;
      margin-left: 10px;
    }
    .phone {
      flex: 1;
      position: relative;
      .code {
        position: absolute;
        right: 0;
        height: 40px;
        line-height: 40px;
        color: #2d8cf0;
        padding: 0 20px;
        cursor: pointer;
        &::after {
          content: "";
          position: absolute;
          left: 0;
          width: 1px;
          height: 20px;
          top: 10px;
          background: #cccccc;
        }
      }
    }
  }
}
</style>
